var map = {
	"./404.vue": [
		"c5Mg",
		14
	],
	"./Help.vue": [
		"v6xc",
		13
	],
	"./Home.vue": [
		"HXef",
		2
	],
	"./Info.vue": [
		"PdC8"
	],
	"./PrivacyPolicy.vue": [
		"jXXe",
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "A14c";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\.vue$
// module id = A14c
// module chunks = 16